import apiClient from './apiClient';

export interface PageViewPayload {
  page: string;
  pageName: string;
  duration: number;
  sessionId: string;
  enteredAt: string;
}

const activityApi = {
  getBadges: () =>
    apiClient.get('/activity/badges').then((r) => r.data),

  getLeaderboard: (type: 'liked' | 'rated' | 'roses') =>
    apiClient.get('/activity/leaderboard', { params: { type } }).then((r) => r.data),

  getCompatibility: (profileId: string) =>
    apiClient.get(`/activity/compatibility/${profileId}`).then((r) => r.data),

  trackPageView: (payload: PageViewPayload) =>
    apiClient.post('/activity/pageview', payload).then((r) => r.data),
};

export default activityApi;
